import lightGallery from 'lightgallery';

export default () => {
  apos.util.widgetPlayers.pdf = {
    selector: '[data-pdf-file-widget]',
    player: function (el) {
      const pdfFiles = el.querySelectorAll('[data-pdf-file-button]');

      // Create an array of your PDFs
      const dynamicPdfs = [ ...pdfFiles ].map((btn, index) => {
        return {
          src: btn.getAttribute('data-src'),
          iframe: true
        };
      });

      // Initialize lightGallery using dynamic mode
      const instance = lightGallery(el, {
        dynamic: true,
        dynamicEl: dynamicPdfs,
        licenseKey: 'EA872E91-6B5D-42AE-8A5E-021676FF3888',
        speed: 500
      });

      // Handle button click
      pdfFiles.forEach((pdfFile, index) => {
        pdfFile.addEventListener('click', (e) => {
          e.preventDefault();

          // Open the gallery at the correct index
          const idx = parseInt(pdfFile.getAttribute('data-index'));
          instance.openGallery(idx);
        });
      });
    }
  };
};
